import { iBuildInIndicator } from '../../iBuildInIndicator';
import { IMAEx } from './iMAEx';
export const iStdDevEx = 'iStdDevEx';
export class IStdDevEx extends iBuildInIndicator {
    constructor(period, maMethod, maShift, priceType) {
        super(1);
        this.FMaPeriod = period;
        this.FMAMethod = maMethod;
        this.FPriceType = priceType;
        this.ma = new IMAEx(period, maMethod, 0, priceType, 0);
        this.ma.Parent = this.Parent;
        this.ma.PriceData = this.PriceData;
        this.FMaShift = maShift;
        this.Data.FArray[0].Shift = this.FMaShift;
    }
    get Name() {
        return iStdDevEx;
    }
    get Key() {
        return this.DefaultKey + this.FMaPeriod + this.FMAMethod + this.FPriceType;
    }
    NextBar(callBound) {
        this.ma.NextBar(callBound);
        super.NextBar(callBound);
    }
    get PriceData() {
        return super.PriceData;
    }
    set PriceData(value) {
        super.PriceData = value;
        this.ma.PriceData = value;
    }
    get Parent() {
        return super.Parent;
    }
    set Parent(value) {
        super.Parent = value;
        this.ma.Parent = value;
    }
    OnQuote(ci, callBound, callFromRefresh = false) {
        this.ma.OnQuote(ci, callBound);
        if (this.FCount < this.FMaPeriod) {
            return;
        }
        let dAmount = 0;
        const dMovingAverage = this.ma.GetValue(0);
        for (let j = 0; j < this.FMaPeriod; j++) {
            const dAPrice = this.GetPrice(this.FPriceType, j);
            dAmount += (dAPrice - dMovingAverage) * (dAPrice - dMovingAverage);
        }
        this.SetValue(0, 0, Math.sqrt(dAmount / this.FMaPeriod));
    }
    Dispose() {
        this.ma.Dispose();
        super.Dispose();
    }
    SetOffset(offset) {
        this.ma.SetOffset(offset);
        super.SetOffset(offset);
    }
    Refresh(count, newThread) {
        this.ma.Dispose();
        this.ma = new IMAEx(this.FMaPeriod, this.FMAMethod, 0, this.FPriceType, 0);
        this.ma.Parent = this.Parent;
        this.ma.PriceData = this.PriceData;
        super.Refresh(count, newThread);
    }
}
